// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ion-content {
  --background: #fff !important;
}
:host ion-list {
  background: var(--cms-app-background-color) !important;
}

.store-page__mobile-header ion-button {
  text-decoration: underline;
}

.store-content {
  --background: var(--ion-background-color, #fff);
}

.store-grid {
  padding: 1rem;
}
.store-grid ion-row {
  margin: 0 -0.5rem;
  display: flex;
  flex-wrap: wrap;
}
.store-grid ion-col {
  padding: 0 0.5rem;
  display: flex;
  align-self: stretch;
}

.store-product-card {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  flex: 1;
  min-height: 280px;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  cursor: pointer;
}

.store-card-image {
  width: 100%;
  aspect-ratio: 1.4/1;
  border-radius: 12px 12px 0 0;
  overflow: hidden;
  background: var(--ion-color-light);
}
.store-card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.store-card-placeholder {
  width: 100%;
  height: 100%;
  min-height: 100px;
  background: var(--ion-color-light);
}

.store-card-title {
  font-weight: 700;
  font-size: 0.95rem !important;
  color: #000;
  margin: 0.75rem 0.5rem 0.25rem;
  line-height: 1.25;
  text-align: center;
  min-height: 2.5em;
  padding: 0 0.25rem;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-clamp: 2;
}

.store-card-points,
.store-card-price {
  font-size: 1rem;
  font-weight: 600;
  color: var(--ion-color-danger, #eb445a);
  margin: 0 0.5rem 0.5rem;
  text-align: center;
}

.store-card-points .store-card-points-value,
.store-card-points .store-card-points-name {
  display: inline;
}

.store-card-button {
  margin: 0 0.5rem 0.75rem;
  margin-top: auto;
  font-weight: 500;
  text-transform: none;
}

.store-loading,
.store-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
}
.store-loading ion-spinner,
.store-empty ion-spinner {
  margin-bottom: 1rem;
}
.store-loading p,
.store-empty p {
  color: var(--ion-color-medium);
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/store/store.page.scss"],"names":[],"mappings":"AACE;EACE,6BAAA;AAAJ;AAGE;EACE,sDAAA;AADJ;;AAKA;EACE,0BAAA;AAFF;;AAKA;EACE,+CAAA;AAFF;;AAKA;EACE,aAAA;AAFF;AAIE;EACE,iBAAA;EACA,aAAA;EACA,eAAA;AAFJ;AAKE;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;AAHJ;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,WAAA;EACA,OAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yCAAA;EACA,eAAA;AAJF;;AAOA;EACE,WAAA;EACA,mBAAA;EACA,4BAAA;EACA,gBAAA;EACA,kCAAA;AAJF;AAME;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAJJ;;AAQA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kCAAA;AALF;;AAQA;EACE,gBAAA;EACA,6BAAA;EACA,WAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,aAAA;AALF;;AAQA;;EAEE,eAAA;EACA,gBAAA;EACA,uCAAA;EACA,uBAAA;EACA,kBAAA;AALF;;AAQA;;EAEE,eAAA;AALF;;AAQA;EACE,wBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;AALF;;AAQA;;EAEE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;AALF;AAOE;;EACE,mBAAA;AAJJ;AAOE;;EACE,8BAAA;EACA,SAAA;AAJJ","sourcesContent":[":host {\n  ion-content {\n    --background: #fff !important;\n  }\n\n  ion-list {\n    background: var(--cms-app-background-color) !important;\n  }\n}\n\n.store-page__mobile-header ion-button {\n  text-decoration: underline;\n}\n\n.store-content {\n  --background: var(--ion-background-color, #fff);\n}\n\n.store-grid {\n  padding: 1rem;\n\n  ion-row {\n    margin: 0 -0.5rem;\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  ion-col {\n    padding: 0 0.5rem;\n    display: flex;\n    align-self: stretch;\n  }\n}\n\n.store-product-card {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  width: 100%;\n  flex: 1;\n  min-height: 280px;\n  background: #fff;\n  border-radius: 12px;\n  overflow: hidden;\n  margin-bottom: 1rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  cursor: pointer;\n}\n\n.store-card-image {\n  width: 100%;\n  aspect-ratio: 1.4 / 1;\n  border-radius: 12px 12px 0 0;\n  overflow: hidden;\n  background: var(--ion-color-light);\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n}\n\n.store-card-placeholder {\n  width: 100%;\n  height: 100%;\n  min-height: 100px;\n  background: var(--ion-color-light);\n}\n\n.store-card-title {\n  font-weight: 700;\n  font-size: 0.95rem !important;\n  color: #000;\n  margin: 0.75rem 0.5rem 0.25rem;\n  line-height: 1.25;\n  text-align: center;\n  min-height: 2.5em;\n  padding: 0 0.25rem;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  line-clamp: 2;\n}\n\n.store-card-points,\n.store-card-price {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--ion-color-danger, #eb445a);\n  margin: 0 0.5rem 0.5rem;\n  text-align: center;\n}\n\n.store-card-points .store-card-points-value,\n.store-card-points .store-card-points-name {\n  display: inline;\n}\n\n.store-card-button {\n  margin: 0 0.5rem 0.75rem;\n  margin-top: auto;\n  font-weight: 500;\n  text-transform: none;\n}\n\n.store-loading,\n.store-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  text-align: center;\n\n  ion-spinner {\n    margin-bottom: 1rem;\n  }\n\n  p {\n    color: var(--ion-color-medium);\n    margin: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
